import Box from '@mui/material/Box'

import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'

import SkyNetTabs from 'app/shared-components/SkyNetTabs'
import TabsDropdown from './TabsDropdown'

/* Component for Tabs in SkyNetObjectProfile */
const Tabs = ({
    tabs,
    isDropDownView,
    activeTab,
    onChange,
}: Readonly<{
    tabs: SkyNetTableTab[]
    isDropDownView: boolean,
    activeTab: number,
    onChange: (el: number) => void,
}>) => {
    return (
        <Box sx={{
            width: '100%',
        }}
        >
            {isDropDownView
                ? (
                    <TabsDropdown
                        tabs={tabs}
                        value={activeTab}
                        onChange={onChange}
                    />
                ) : (
                    <SkyNetTabs
                        tabs={tabs}
                        value={activeTab}
                        onChange={onChange}
                    />
                )}

        </Box>
    )
}

export default Tabs
